import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(Authentication)/forgot-password/page.tsx");
